import { Attendee, createEvent, DateArray } from 'ics';

import { EventType } from '../../org/event-type/event-type';
import { EventData } from '../event-data/event-data';

export const createIcs = (params: {
  userName: string;
  userEmail: string;
  eventData: EventData;
  eventType: EventType;
  description: string;
  organizerEmail: string;
}): string => {
  /* eslint-disable */
  const startUTC = params.eventData.getStart().utc();
  const startArray: DateArray = [
    startUTC.year(),
    startUTC.month() + 1,
    startUTC.date(),
    startUTC.hour(),
    startUTC.minute(),
  ];

  const endUTC = params.eventData.getEnd().utc();
  const endArray: DateArray = [endUTC.year(), endUTC.month() + 1, endUTC.date(), endUTC.hour(), endUTC.minute()];
  /* eslint-enable */

  /**************************************************************************************************
   * Attendees
   *
   * Create the list of attendees. In rare situations, the organizer email and the attendee email
   * is the same. If the organizer email and the attendee email is the same then Gmail will not
   * render the calendar invite we generate.Hence, it will not be able to parse the ics properly.
   *
   * https://stackoverflow.com/questions/67149571/how-to-send-ics-calendar-invite-through-sendgrid-so-that-it-renders-in-email-cl
   *
   *************************************************************************************************/

  const attendees: Attendee[] = [
    {
      name: params.userName || '',
      email: params.userEmail || '',
      rsvp: true,
      partstat: 'ACCEPTED',
      role: 'REQ-PARTICIPANT',
    },
  ];

  /**************************************************************************************************
   * Create the calendar invite
   * ************************************************************************************************/
  const { value } = createEvent({
    /**
     * Note: We don't specify the uid field intentionally. This is because the second time the same
     * uid is specified, Gmail will not parse the associated calendar invite. This makes debugging
     * difficult. It may also create strange situations if a calendar invite to one event is requested
     * multiple times by the same person or the same email address. The ics library will randomly
     * generate a uid if it is not specified.
     *
     *  ---> We specifically don't do this:
     *     uid: params.eventData.getId(),
     */
    start: startArray,
    end: endArray,
    startInputType: 'utc',
    endInputType: 'utc',
    title: params.eventType.getDisplayName(),
    description: params.description || '',
    location: '', // you can use a link here if it is online
    status: 'CONFIRMED',
    organizer: { name: params.organizerEmail, email: params.organizerEmail },
    attendees,
    method: 'REQUEST',
    productId: 'helplinesoftware.com',
  });

  if (value === undefined) {
    throw new Error('Unable to create event');
  }

  return value;
};
